import React, { ChangeEvent, FC, FormEvent, useEffect, useState } from "react";
import { ModalProps } from "../../../helpers/constants";
import Modal from "../../../components/common/form/Modal";
import Form from "../../../components/common/form/Form";
import { DataTableColumn } from "../../../components/common/datatable/DataTableTypes";
import { DataTable } from "../../../components/common/datatable/DataTable";
import {
    useDeliverFileMutation,
    useGetDeliveryModalDocumentsQuery,
    useLazyViewDeliverDocumentsQuery,
    useLazyViewFileQuery,
} from "../orderFilesApi";
import { formatValueAsDateAndTime } from "../../../helpers/utils/DateUtils";
import ButtonTray from "../../../components/common/form/ButtonTray";
import { loadPdf } from "../../../helpers/utils/Utils";

interface Props extends ModalProps {
    productId: any;
    orderId: any;
}

const DocumentDownloadModal: FC<Props> = ({ show, setShow, orderId }) => {
    const [fileId, setFileId] = useState<string | null>(null);
    const [viewFile, { isFetching }] = useLazyViewDeliverDocumentsQuery();
    const [docList, setDocList] = useState<any>([]);
    const [date, setDate] = useState("");

    const { data: documentData } = useGetDeliveryModalDocumentsQuery({
        orderFileType: ["TaxCertificate", "HOAFull", "HOAContact", "CADPrintout", "SOA", "NTP", "NOO", "INVOICE", "Other"],
        orderId,
        "sortOrder": "desc",
    });

    useEffect(() => {
        if (documentData?.data?.length > 0) {
            setFileId(documentData?.data[0].id);
        }
    }, [documentData]);

    useEffect(() => {
        if (fileId) {
            viewFile({ fileId, isDownload: false, isOpenInFrame: true });
        }
    }, [fileId]);

    const columns: DataTableColumn[] = [
        {
            label: "",
            accessor: "id", canSort: false,
            cell: (props: any) => {
                return <>
                    <input type="checkbox" id={props.row.original.id} onChange={(e: any) => {
                        if (docList.length !== 0) {
                            const result = docList.map((e: any) => e.id).includes(props.row.original.id);
                            if (result) {
                                const k = docList.map((e: any) => e.id).indexOf(props.row.original.id);
                                if (k > -1) {
                                    docList.splice(k, 1);
                                }
                            } else {
                                docList.push(props.row.original);
                            }
                        } else {
                            docList.push(props.row.original);
                        }
                        setDate(props.row.original.id + Date.now());
                    }} onClick={(e) => {
                        loadPdf(props.row.original.id);
                        setDate(props.row.original.id + Date.now())
                    }} defaultChecked={docList.map((e: any) => e.id).indexOf(props.row.original.id) > -1} />
                </>
            }
        },
        {
            label: "Name",
            accessor: "filename",
            canSort: false,
        },
        {
            label: "Type",
            accessor: "fileType",
        },
        {
            label: "Delivered",
            accessor: "dateDelivered",
            cell: (props: any) => formatValueAsDateAndTime(props.row.original.dateDelivered),
        },
    ];

    const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        // Trigger file download requests and wait for all to complete
        try {
            await Promise.all(
                docList.map((el: any) =>
                    viewFile({ fileId: el?.id, isDownload: true }).unwrap() // Assuming viewFile returns a promise
                )
            );
        } catch (error) {
            console.error("Error downloading files:", error);
        }

        // After all downloads complete, close the modal and reset state
        setShow(false);
        setDocList([]);
    }


    return (
        <Modal
            title="Download Documents"
            show={show}
            setShow={setShow}
            className="w-5/6"
            fields={

                <>
                    <p className="ml-1 text-surface-0">Select the documents you would like to deliver</p>
                    <div className="md:grid sm:block grid-cols-12 gap-3">
                        <div className="col-span-5">
                            <DataTable
                                columns={columns}
                                defaultFilter={{
                                    orderFileType: ["TaxCertificate", "HOAFull", "HOAContact", "CADPrintout", "SOA", "NTP", "NOO", "INVOICE", "Other"],
                                    orderId,
                                    "sortOrder": "desc",
                                }}
                                actions={{
                                    fetchAction: useGetDeliveryModalDocumentsQuery,
                                }}
                                renderOptions={{
                                    skipUserSettingRender: true,
                                }}
                                appendFilterToUrl={false}
                            />
                        </div>
                        <div className="col-span-7">
                            <iframe
                                src={""}
                                style={{ width: "100%", minHeight: "500px", overflow: "visible" }}
                                width="100%"
                                height="100%"
                            />
                        </div>
                    </div>


                    <div className="border-t border-surface-5 flex justify-end mt-4">

                        <ButtonTray
                            buttons={[
                                {
                                    buttonProps: {
                                        btnText: "Cancel",
                                        onClick: () => setShow(false),
                                        type: "close",
                                    },
                                    buttonType: "button"
                                },
                                {
                                    buttonProps: {
                                        btnText: "Download",
                                        type: "submit",
                                        onClick: handleSubmit,
                                        isLoading: (isFetching),
                                        isDisabled: docList.length === 0
                                    },
                                    buttonType: "button",

                                }
                            ]}
                            align="end"
                            gap={2}
                        />

                    </div>
                </>
            } />

    );
};

export default DocumentDownloadModal;
